export enum FormTransitionFieldType {
  UserSetting = 1,
  FormField = 2,
}
